'use client';

import parse from 'html-react-parser';
import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
const SidePopUp = dynamic(() =>
  import('@/components/report-page/toc-section/toc-side-popUp')
);

const TocPopUp = dynamic(() => import('./toc-pop-up'));

export default function TocSection({
  TOC,
  keyword,
  reportId,
  CustomName,
  regionalText,
  lang,
}) {
  const [isTocActive, setIsTocActive] = useState(false);
  const [isPopUpShown, setIsPopUpShown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  let isTocOpened = false;

  useEffect(() => {
    const tocNav = document.getElementById('TOC-nav');
    const tocNavTop = tocNav.offsetTop;
    const tocNavHeight = tocNav.offsetHeight;
    const tocNavBottom = tocNavTop + tocNavHeight;

    const handleToc = () => {
      if (
        tocNavTop <= window.scrollY + 100 &&
        window.scrollY <= tocNavBottom - 120
      ) {
        setIsTocActive(true);
      } else {
        setIsTocActive(false);
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleToc);

      return () => {
        window.removeEventListener('scroll', handleToc);
      };
    }
  });

  return (
    <section id="TOC-nav" className="toc-headings list relative">
      {isTocActive && !isPopUpShown ? (
        <SidePopUp
          reportId={reportId}
          setIsTocActive={setIsTocActive}
          setIsPopUpShown={setIsPopUpShown}
          keyword={keyword}
          CustomName={CustomName}
          lang={lang}
        />
      ) : (
        ''
      )}
      <h3 className="report-title my-2">
        {keyword} {regionalText}
      </h3>
      <div
        onClick={(e) => {
          e.stopPropagation();
          if (!isTocOpened) {
            setIsOpen(true);
          }
          isTocOpened = true;
        }}
        className="ms-5"
      >
        {parse(TOC || '')}
      </div>
      <TocPopUp
        keyword={keyword}
        reportId={reportId}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        CustomName={CustomName}
      />
    </section>
  );
}
